import React from "react";
import { Helmet } from "react-helmet";
import '../../styles/lyrics.css';

const BeeteLamhe = () => {
  return (
    <div>
      <Helmet>
        <title>LYRICS - BEETE LAMHE</title>
      </Helmet>

      <section class="lyrics-catalog">
        <p style={{fontSize: '50px', color: '#ffffff', lineHeight: '90%', marginBottom: '60px'}}>LYRICS - BEETE LAMHE</p>
        <div class="lyrics-frames">
        <div class="lyrics">
                [Verse 1]<br/>
                Raatbhar yaado me teri<br/>
                Aur rakhi thi jaan ko naajuk hatheli me<br/>
                Tujhe basa lun mai saanso me meri<br/>
                Sirf nikle jubaan se jo baate wo gehri<br/>
                Salakho me kaidi ab milta nai chain<br/>
                Dooriyan ab mujhse hoti nai sehen<br/>
                Gham teri yaado me nam mere nain<br/>
                Waada hamesha ka tha lekin bhar<br/>
                Saza de di zindagi bhar ki<br/>
                Maana kisi ki na galti<br/>
                Tu na rahi mere saath jo<br/>
                Shayad usi ki thi marzi<br/>
                Bas chahat thi rakhna sirf apna banake<br/>
                Main bachpan se tha baitha sapna sajake<br/>
                Ab tera bina mann nai lagta yahan pe<br/>
                Rahun na rahun main, yaad rakhna humare<br/>
                <br/>
                [Chorus]<br/>
                Beete lamhe (Beete lamhe)<br/>
                Beete lamhe (Beete lamhe)<br/>
                Milta nai chain, milta nai chain<br/>
                Milta nai chain<br/>
                Aati hai yaad wo<br/>
                <br/>
                Beete lamhe (Beete lamhe)<br/>
                Beet&#1077; lamhe (Beete lamhe)<br/>
                Milta nai chain, milta nai chain<br/>
                Milta nai chain<br/>
                Aati hai yaad wo<br/>
                <br/>
                [Verse 2]<br/>
                Wo k&#1077;hti thi lejaana ghar mujhe<br/>
                Wo kehti nai rehta sabar mujhe<br/>
                Wo kehti dena har pal mujhe<br/>
                Wo kehti andekha na kar mujhe<br/>
                Aur ab jo rahi na toh milta sukoon nai<br/>
                Aur ab jo rahi na toh dikhta guroor nai<br/>
                Main khud ke khilaf, meri jung hai androoni<br/>
                Kyun bana main khud apne khwabo ka khooni<br/>
                Ab shayad milenge ab hum dono marke<br/>
                Ya agle janam me yun rooh meri tadpe<br/>
                Wo chhod gayi dard me bas yaad aaye lamhe<br/>
                Dua hai khuda tujhe lambi umar de<br/>
                Ab sarpe hai karze ye kaafi bai bojh<br/>
                Tujhse bichad ke saza di hai maut<br/>
                Ab bhi wafa mujh me baaki hai boht<br/>
                Par milta nai chain satati hai roj<br/>
                <br/>
                [Chorus]<br/>
                Beete lamhe (Beete lamhe)<br/>
                Beete lamhe (Beete lamhe)<br/>
                Milta nai chain, milta nai chain<br/>
                Milta nai chain<br/>
                Aati hai yaad wo<br/>
                <br/>
                Beete lamhe (Beete lamhe)<br/>
                Beete lamhe (Beete lamhe)<br/>
                Milta nai chain, milta nai chain<br/>
                Milta nai chain<br/>
                Aati hai yaad wo<br/>
                <br/>
                Hoooo-oooo<br/>
                Hhhaaaaaa<br/>
                Hooo-ohooo<br/>
                Ahhhhhh
            </div>
        </div>
    </section>
      

    </div>
  );
};

export default BeeteLamhe;
